import { render, staticRenderFns } from "./CotizacionesAgentes.vue?vue&type=template&id=13798242"
import script from "./CotizacionesAgentes.vue?vue&type=script&lang=js"
export * from "./CotizacionesAgentes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports